import { createContext, useContext, useMemo, useState } from "react";

const EnquiryContext = createContext({ service: "", setService: () => {} });

export const EnquiryProvider = ({ children }) => {
    const [service, setService] = useState("");
    const value = useMemo(() => ({ service, setService }), [service]);
    return <EnquiryContext.Provider value={value}>{children}</EnquiryContext.Provider>;
};

export const useEnquiry = () => useContext(EnquiryContext);
